module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_an@3x-f7b2b8526bb4a9b9762c22c2bb345b10.webp";